module.exports = __webpack_public_path__ + "img/des2.0c06c341.png";